import React from 'react'

export function IconCreditCardSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path
        d="M19.5 14.5C19.5 15.3284 18.8284 16 18 16H3C2.17157 16 1.5 15.3284 1.5 14.5V8.5H19.5V14.5ZM4.25 12.5C3.83579 12.5 3.5 12.8358 3.5 13.25C3.5 13.6642 3.83579 14 4.25 14H5.75L5.82715 13.9961C6.20512 13.9575 6.5 13.6382 6.5 13.25C6.5 12.8618 6.20512 12.5425 5.82715 12.5039L5.75 12.5H4.25ZM8.25 12.5C7.83579 12.5 7.5 12.8358 7.5 13.25C7.5 13.6642 7.83579 14 8.25 14H11.75L11.8271 13.9961C12.2051 13.9575 12.5 13.6382 12.5 13.25C12.5 12.8618 12.2051 12.5425 11.8271 12.5039L11.75 12.5H8.25ZM18 4C18.8284 4 19.5 4.67157 19.5 5.5V6H1.5V5.5C1.5 4.67157 2.17157 4 3 4H18Z"
        fill="#896145"
      />
    </svg>
  )
}
